import { createElement } from 'react';
import { store } from '../store';
import { observer } from 'mobx-react';
import flowRight from 'lodash.flowright';
import withStyles, { WithStyles } from 'react-jss';

const styles = {
    rightPanel: {
        flexBasis: 300,
        overflow: 'scroll',
        maxHeight: 'calc(100vh - 60px)',
        backgroundColor: '#373D49',
        color: '#a0aabf',
    },
};

interface IProps extends WithStyles<typeof styles> {}

const component: React.FunctionComponent<IProps> = ({ classes }) => {
    let C = store.rightPanelComponent;
    console.log('right panel', store.rightPanelComponentDescriptor);
    return (
        <div className={classes.rightPanel}>
            {C ? <C descriptor={store.rightPanelComponentDescriptor} /> : null}
        </div>
    );
};

export default flowRight([withStyles(styles), observer])(component);
